(() => {
  'use strict';
  if (window.PLCAvoneBridge) return;
  window.PLCAvoneBridge = true;
  const supportsDialog = typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function';
  const isNativeCartForm = form => {
    if (!(form instanceof HTMLFormElement) || !form.closest('.avone-module')) return false;
    let action;
    try { action = new URL(form.action || '', location.href); } catch { return false; }
    return action.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(action.pathname) && Boolean(form.querySelector('[name="id"]'));
  };
  function prepare(root = document) {
    root.querySelectorAll('.avone-module form').forEach(form => {
      if (!isNativeCartForm(form)) return;
      form.setAttribute('data-cart-add', '');
      if (!form.querySelector('[data-form-error]')) {
        const error = document.createElement('p');
        error.className = 'form-error';
        error.setAttribute('data-form-error', '');
        error.setAttribute('role', 'alert');
        error.hidden = true;
        form.append(error);
      }
    });
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!supportsDialog || !window.PLCStorefront || !isNativeCartForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (event.submitter?.disabled || event.submitter?.getAttribute('aria-disabled') === 'true') return;
    prepare(form.closest('.avone-module'));
    form.setAttribute('data-cart-add', '');
    window.PLCStorefront.add(form);
  }, true);
  function enclosePopups() {
    document.querySelectorAll('body > .tingle-modal, body > .pswp, body > .drift-zoom-pane').forEach(popup => {
      const wrapper = document.createElement('div');
      wrapper.className = 'avone-module plc-avone-popup-scope';
      wrapper.style.display = 'contents';
      popup.before(wrapper);
      wrapper.append(popup);
      prepare(wrapper);
    });
  }
  prepare();
  enclosePopups();
  const observer = new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) {
      enclosePopups();
      prepare();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const loadedScripts = new Map(Array.from(document.scripts).filter(script => script.src).map(script => [script.src, Promise.resolve()]));
  async function activateSectionScripts(section) {
    if (!(section instanceof Element) || !section.matches('.avone-module')) return;
    for (const source of section.querySelectorAll('script[src]')) {
      const url = new URL(source.src, location.href);
      const local = url.origin === location.origin;
      const themeCDN = /(^|\.)shopify(?:cdn)?\.com$/.test(url.hostname) && url.pathname.includes('/assets/');
      if (!['https:', 'http:'].includes(url.protocol) || (!local && !themeCDN)) continue;
      if (!loadedScripts.has(url.href)) {
        const promise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url.href;
          script.async = false;
          if (source.type) script.type = source.type;
          if (source.crossOrigin) script.crossOrigin = source.crossOrigin;
          script.onload = resolve;
          script.onerror = () => reject(new Error('Avone asset could not be loaded'));
          document.head.append(script);
        });
        loadedScripts.set(url.href, promise);
      }
      try { await loadedScripts.get(url.href); }
      catch { document.dispatchEvent(new CustomEvent('plc:avone:asset-error', { detail: { url: url.href } })); }
    }
  }
  window.PLCAvoneComponents = Object.freeze({
    prepare,
    activate: activateSectionScripts
  });
  document.addEventListener('shopify:section:load', event => {
    prepare();
    enclosePopups();
    activateSectionScripts(event.target);
  });
})();
